// extracted by mini-css-extract-plugin
export var box = "_83-1";
export var checked = "_83-2";
export var descriptionSpacer = "_83-9";
export var disabled = "_83-3";
export var icon = "_83-6";
export var input = "_83-0";
export var labelSpacer = "_83-8";
export var medium = "_83-5";
export var small = "_83-4";
export var text = "_83-7";